export default "__VITE_ASSET__AhnCkQYN__"